import { useEffect } from 'react';

/**
 * Sets Open Graph and Twitter meta tags for the current page.
 * Call from any page component to override the defaults in index.html.
 */
const usePageMeta = ({ title, description, image, url }) => {
  useEffect(() => {
    const base = 'ElevateMN';
    const fullTitle = title ? `${title} | ${base}` : `${base} | Mental Health & Community Support`;
    const origin = window.location.origin;

    document.title = fullTitle;

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:url', url || window.location.href);
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }
    if (image) {
      const fullImage = image.startsWith('http') ? image : `${origin}${image}`;
      setMeta('property', 'og:image', fullImage);
      setMeta('name', 'twitter:image', fullImage);
    }
    setMeta('name', 'twitter:title', fullTitle);

    return () => {
      // Reset to defaults
      document.title = `${base} | Mental Health & Community Support`;
    };
  }, [title, description, image, url]);
};

export default usePageMeta;
